import { actionId } from './types';

export const EDIT = 'edit' as const;
export const RENAME = 'rename' as const;
export const DELETE = 'delete' as const;
export const PDF = 'pdf' as const;
export const COPY = 'copy' as const;
export const SHARE = 'share' as const;
export const ASSISTANT = 'assistant' as const;
export const CREATE_PDF = 'createPdf' as const;
export const COPY_PDF_LINK = 'copyPdfLink' as const;
export const UPDATE_PDF = 'updatePdf' as const;

export const ALL_ACTIONS_LIST: actionId[] = [
  EDIT,
  COPY,
  RENAME,
  SHARE,
  DELETE,
  PDF,
  ASSISTANT,
  CREATE_PDF,
  COPY_PDF_LINK,
  UPDATE_PDF,
];
export const TEMPORARY_FREE_ACTIONS_LIST: actionId[] = [
  // temporary
  EDIT,
  RENAME,
  SHARE,
  PDF,
  ASSISTANT,
  CREATE_PDF,
  COPY_PDF_LINK,
  UPDATE_PDF,
];

export const VIEWONLY_ACTIONS_LIST: actionId[] = [DELETE];

export const FREE_SUBSCRIPTION_ACTIONS_LIST: actionId[] = TEMPORARY_FREE_ACTIONS_LIST;
export const STARTER_SUBSCRIPTION_ACTIONS_LIST: actionId[] = [EDIT, COPY, RENAME, DELETE];

export const LIGHT_SUBSCRIPTION_ACTIONS_LIST: actionId[] = ALL_ACTIONS_LIST;

export const STANDARD_SUBSCRIPTION_ACTIONS_LIST: actionId[] = ALL_ACTIONS_LIST;

export const UNAUTHORIZED_SUBSCRIPTION_ACTIONS_LIST: actionId[] = [];

export const ONE_PAGE_TYPE_ACTION_LIST: actionId[] = [EDIT, COPY, RENAME, SHARE, DELETE];

export const FOR_BANK_TYPE_ACTION_LIST: actionId[] = ALL_ACTIONS_LIST;
